/*
  Centers a collection grid's products when the WHOLE result set fits in a
  single row -- e.g. a mega-menu size filter (assets/mega-menu.js) landing
  on /collections/all?filter.v.option.size=55mm often returns 1-3 products,
  which the theme's default float grid (sections/main-collection.liquid,
  .grid__item{float:left}) left-aligns with the rest of the row empty.

  A full multi-row grid must NOT be touched, including its own partial
  last row -- only "everything fits in one row" centers. Per-row column
  count is a per-section, per-breakpoint theme-editor setting (product_grid
  block's per_row_desktop/per_row_mobile, see main-collection.liquid), so
  there's no fixed number to hardcode in CSS; instead this measures the
  ACTUAL rendered layout -- if every product card shares the same
  offsetTop as the first one, the whole set is one row, full stop,
  regardless of which breakpoint or column-count setting produced that.
  [data-grid-single-row] on the container is what assets/eva-grid-
  center.css keys off of (display:flex + justify-content:center; safe
  precisely because a true single row never wraps, so centering the one
  flex line can never also center a multi-row grid's partial last row).

  Re-run on: initial load, window resize (debounced), after eva-pjax.js
  swaps #MainContent (`eva:pjax:loaded`), and after the theme's own
  in-page ajax filter/sort updates the grid without a full PJAX swap
  (`collection:reloaded`, dispatched by theme.js's CollectionFilter --
  see theme.js renderCollectionPage).
*/
(function () {
  function getContainer() {
    return document.querySelector('[data-collection-container]');
  }

  function updateOne(container) {
    var items = container.querySelectorAll(':scope > .grid-product');
    if (!items.length) {
      container.removeAttribute('data-grid-single-row');
      return;
    }
    var firstTop = items[0].offsetTop;
    var singleRow = true;
    for (var i = 1; i < items.length; i++) {
      // A couple of px of tolerance absorbs subpixel layout rounding
      // without risking a false positive across a real second row (real
      // rows differ by a full card height, never a couple of px).
      if (Math.abs(items[i].offsetTop - firstTop) > 2) {
        singleRow = false;
        break;
      }
    }
    if (singleRow) {
      container.setAttribute('data-grid-single-row', '');
    } else {
      container.removeAttribute('data-grid-single-row');
    }
  }

  function update() {
    var container = getContainer();
    if (!container) { return; }
    updateOne(container);
  }

  var resizeTimer = null;
  function onResize() {
    clearTimeout(resizeTimer);
    resizeTimer = setTimeout(update, 150);
  }

  function ready(fn) {
    if (document.readyState !== 'loading') { fn(); }
    else { document.addEventListener('DOMContentLoaded', fn); }
  }

  ready(update);
  window.addEventListener('resize', onResize);
  document.addEventListener('eva:pjax:loaded', update);
  document.addEventListener('collection:reloaded', update);
})();
